import React from 'react';
import HorecaLayout from './HorecaLayout';
import HerocaAboutUsBanner from './components/horeca/horecaaboutusbanner';
import HorecaAbout from './components/horeca/horecaabout';
import Chairman from './components/horeca/chairman';
import Sustainablility from './components/horeca/sustainability';
import HorecaPresence from './components/horeca/horecapresence';
import Values from './components/horeca/values';



const HorecaAboutUs = () => {


    return(<>
    <HorecaLayout >
        <HerocaAboutUsBanner/>
        <div className='mt-5'><HorecaAbout/></div>
        <Values/>
        <Chairman/>
        <Sustainablility/>
        <HorecaPresence/>         

    </HorecaLayout >
    </>);


}

export default HorecaAboutUs;